module.exports = __webpack_public_path__ + "a4f4c418cf137d7dcca20201ae934b6b.svg";